<template>
<v-app>
  <v-app-bar app color="primary" dark>
    <v-toolbar-title>
      <span>Sistema de Matrícula Online da UFFS - {{ $route.meta.titulo }}</span>
    </v-toolbar-title>
    <v-spacer />
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn tile text large v-on="on">
          <v-icon left>mdi-account</v-icon> 
          {{ username }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="logOut">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-information</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ versaosistema }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
     <v-main class="fill-height" fluid no-gutters>
      <slot />
    </v-main>
</v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import * as InfoService from "@/services/info.service";

export default {
  data() {
    return {
      versaosistema: 0,
    };
  },
  mounted() {  
    InfoService.getVersaoSistema()
      .then( (res) => this.versaosistema = res.data)
  },
  methods : {
    logOut() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
  computed: {
    ...mapGetters(
    [
      'loggedUser',
    ]),
    username() {
      if (this.loggedUser)
        return this.loggedUser.nome;
      return '';
    },
    menu() {
      let menu = [];
      menu.push({
        link: { name: 'home'},
        icon: 'mdi-view-dashboard-outline',
        text: 'Home'
      });
      return menu;
    }
  }
}
</script>
